export type AIParseEventRequest = {
  text: string;
  class_id: number | null;
  timezone: string;
  default_duration_minutes: number;
};

export function buildAIParseEventRequest(text: string, classId: number | null): AIParseEventRequest {
  return {
    text,
    class_id: classId,
    timezone: "Europe/Dublin",
    default_duration_minutes: 60,
  };
}
